export enum Theme {
  default = 'default',
  modal = 'modal',
  accordion = 'accordion',
}

export type ThemeString = 'default' | 'modal' | 'accordion' | Theme;
